import { useStyle } from "./style";
import { useTranslation } from "react-i18next";
import { RemoveIcon } from "@/components/icons/icons";
import { contactInputs1 } from "../../inputs/contact-inputs";
import { FormInput } from "@/components/form-inputs/form-input";
import { IInput } from "@/components/form-inputs/interfaces";
import { Stack } from "@mui/material";
import type { CustomerRequiredFieldRules } from "@/utils/customer-required-fields";
import { TrashIcon } from "@/components/icons/trash-icon";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";

interface IProps {
  contact: {
    id?: string;
    firstName?: string;
    lastName?: string;
    title?: string;
    position?: string;
    address?: string;
    tel1?: number;
    tel2?: number;
    phone?: number;
    mail?: string;
    index?: number;
  };
  onDelete: (value: number) => void;
  setContact: any;
  customerRequiredFieldRules: CustomerRequiredFieldRules;
}

const ContactForm = ({
  contact,
  onDelete,
  setContact,
  customerRequiredFieldRules,
}: IProps) => {
  const { classes } = useStyle();
  const { t } = useTranslation();
  const { errorColor } = useGomakeTheme();
  const onChangeInputs = (key, value) => {
    setContact({ ...contact, [key]: value });
  };

  return (
    <div>
      <div style={classes.customerInfoStyle}>
        {contactInputs1(contact, customerRequiredFieldRules).map((item) => (
          <div style={{ marginBottom: 10 }} key={`${contact.index}-${item.name}`}>
            <FormInput
              input={item as IInput}
              changeState={onChangeInputs}
              error={
                !!(item.required && !item.value) ||
                (item.required && item.isValid === false)
              }
              readonly={false}
            />
          </div>
        ))}
      </div>
      <Stack direction={"row"} marginTop={"10px"} marginBottom={"10px"}>
        <a
          style={classes.removeFormStyle}
          onClick={() => onDelete(contact.index)}
        >
          <TrashIcon color={errorColor(500)} height={20} width={20} />
          <button style={classes.buttonsStyle} type="button">
            {t("customers.buttons.remove")}
          </button>
        </a>
      </Stack>
    </div>
  );
};

export { ContactForm };
